import { render } from "./HousePartialDetailsComponent.vue?vue&type=template&id=2a0942a4"
import script from "./HousePartialDetailsComponent.vue?vue&type=script&lang=js"
export * from "./HousePartialDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__